module.exports = __webpack_public_path__ + "static/media/locked-chest.d7e1b06a.svg";